export default __webpack_public_path__ + "static/media/completed.e9d5ff7c.jpg";